import { createSelector } from '@reduxjs/toolkit';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import { selectApartmentsValue } from '../apartments/selectApartmentsValue';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';
import { getAllowedPromoSearchTypes } from '../../../../packages/JsonQuery';

export const selectDiscountPromoSearchTypeOptions = createSelector(
  [selectPromoSearchTypes, selectApartmentsValue],
  (promoSearchTypes, apartments) => {
    if (!promoSearchTypes) {
      return [];
    }

    const promoSearchTypeValues = getPromoSearchFilterValuesByType('discount', promoSearchTypes);
    const allowedPromoSearchTypes = getAllowedPromoSearchTypes(apartments, promoSearchTypeValues);

    return [
      { label: 'Неважно', value: null },
      ...allowedPromoSearchTypes.map(value => {
        const label = promoSearchTypes.discount.find(type => type.value === value)?.name ?? '';

        return {
          value,
          label,
        };
      }),
    ];
  },
);
